import { render } from "./AddConfigurationsToListModal.vue?vue&type=template&id=233da702"
import script from "./AddConfigurationsToListModal.vue?vue&type=script&lang=js"
export * from "./AddConfigurationsToListModal.vue?vue&type=script&lang=js"

import "./AddConfigurationsToListModal.vue?vue&type=style&index=0&id=233da702&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__